import React from "react";

import { createPortal } from "react-dom";
import classnames from "classnames";

import { useMountTransition } from "hooks/useMountTransition";
import { Button, ModalWrapper } from "components/index";
import { downloadFile } from "utils/file/download-file";
import { IImagePlaceholderProps } from "../interfaces";
import { getNestedObjValue } from "../helpers";

import "./image-placeholder.styles.scss";

export const ImagePlaceHolder = ({ rowData, value = undefined }: IImagePlaceholderProps) => {
    const { row, fieldName } = rowData;

    const content = value || getNestedObjValue(row, fieldName.split("."));

    if (!content) return <></>;

    const handleDownload = () => {
        const file = content.includes("8000") ? content.split(/8000(.*)/)[1] : content;

        downloadFile({ data: { file, name: rowData.row?.name } });
    };

    return (
        <>
            <div
                className="image-placeholder input-placeholder d-flex justify-content-center align-items-center"
                id="input-placeholder"
                key={`prime-input-select-${fieldName}-${row.id}`}
            >
                <ModalWrapper icon={{ name: ["fas", "magnifying-glass"] }}>
                    {(modalOpen, closeModal) => <ImagePreview modalOpen={modalOpen} content={content} closeModal={closeModal} />}
                </ModalWrapper>
                <Button icon={{ name: ["fas", "download"] }} onClick={handleDownload} withoutPerm />
            </div>
        </>
    );
};

interface ImagePreviewProps {
    modalOpen: boolean;
    content: string;
    closeModal: () => void;
}

const ImagePreview = ({ modalOpen, closeModal, content }: ImagePreviewProps) => {
    const hasMountTransition = useMountTransition(modalOpen);

    return createPortal(
        <div className={classnames("preview-image-popup", { transition: hasMountTransition, open: modalOpen })} onClick={closeModal}>
            <img src={content} />
        </div>,
        document.body
    );
};
